import { render, staticRenderFns } from "./releaseItem.vue?vue&type=template&id=167dfb3c&scoped=true&"
import script from "./releaseItem.vue?vue&type=script&lang=js&"
export * from "./releaseItem.vue?vue&type=script&lang=js&"
import style0 from "./releaseItem.vue?vue&type=style&index=0&id=167dfb3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167dfb3c",
  null
  
)

export default component.exports